import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";
import {
  Form,
  Button,
  InputGroup,
  FormControl,
  ListGroup,
  Table,
  ButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { connect } from "react-redux";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import EditCustomer from "../CustomersScreen/EditCustomer";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";
import interestModule from "../../../Modules/interest/interestModule";
import moment from "moment";
import { monthDiff } from "../../../Modules/utils/etc";

const SCREEN_NAME = "EDIT_ACCOUNT_SCREEN";

class EditAccountInner extends AppComponent {
  state = {
    interestRate: this.props.account?.interestRate?.toString() || "",
    avgYearlyInterestRate:
      interestModule.calculateAvgYearlyInterest(this.props.account) || "",
    customer: this.props.account?.customer,
    interestPeriod: this.props.account?.interestPeriod || "monthly",
    collector:
      this.props.account?.collector?._id || this.props.account?.collector || "",
    collectorCommission: this.props?.account?._id
      ? this.props?.account?.collectorCommission || 0
      : 3,
    note: this.props.account?.note || "",
    customerQuery: "",
    customers: null,

    accountType: this.props.account?.accountType || "loan",
    depositInterval: this.props.account?.depositInterval || "monthly",
    recurringPeriod: this.props.account?._id
      ? monthDiff(this.props.account.openingDate, this.props.account.endingDate)
      : "6",
    recurringAmount: this.props.account?.recurringAmount || "",
    openingDate: this.props.account?.openingDate || new Date(),
    endingDate: this.props.account?._id
      ? this.props.account?.endingDate || ""
      : this.calcDate({ month: 6, day: -1, date: new Date() }),
    returningDate: this.props.account?._id
      ? this.props.account?.returningDate || ""
      : this.calcDate({ month: 6, day: 4, date: new Date() }),
    extra: this.props.account?.extra || {},
  };

  formRef = React.createRef(null);

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({ limit: 0 }),
      });
      this.props.setScreenState({ agents }, false, "AGENTS_SCREEN");
    } catch (e) {
      this.setAsyncState({ error: e.message });
    }
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      if (!this.state.customer?._id) {
        throw new Error("Select Customer");
      }

      this.setAsyncState({ loading: true, error: null });
      let payload =
        this.state.accountType === "loan"
          ? _.pick(this.state, [
              "interestRate",
              "customer",
              "collector",
              "collectorCommission",
              "interestPeriod",
              "note",
              "accountType",
              "extra",
            ])
          : this.state.accountType === "deposit"
          ? _.pick(this.state, [
              "interestRate",
              "customer",
              "collector",
              "collectorCommission",
              "note",
              "depositInterval",
              "openingDate",
              "endingDate",
              "returningDate",
              "accountType",
              "recurringAmount",
              "extra",
            ])
          : {};

      payload = {
        ...payload,
        customer: payload.customer?._id,
      };

      if (
        payload.openingDate &&
        payload.endingDate &&
        new Date(payload.openingDate).getTime() >
          new Date(payload.endingDate).getTime()
      ) {
        throw new Error("Ending Date must be greater than opening date");
      }

      if (
        payload.returningDate &&
        payload.endingDate &&
        new Date(payload.endingDate).getTime() >
          new Date(payload.returningDate).getTime()
      ) {
        throw new Error("Returning Date must be greater than ending date");
      }

      let updatedAccount = null;
      if (this.props.account?._id) {
        await api.patch(
          `v1/account/${this.props.account._id}`,
          _.pick(
            payload,
            this.props.account.accountType === "deposit"
              ? [
                  "collector",
                  "collectorCommission",
                  "note",
                  "depositInterval",
                  "openingDate",
                  "endingDate",
                  "returningDate",
                  "interestRate",
                  "recurringAmount",
                  "extra",
                ]
              : ["collector", "collectorCommission", "note", "extra"]
          )
        );
        updatedAccount = this.props.account;
      } else {
        const { account } = await api.post("v1/account", payload);
        updatedAccount = account;
      }

      updatedAccount = await api
        .get("v1/account", {
          queryStr: JSON.stringify({
            where: { _id: updatedAccount._id },
            limit: 1,
          }),
        })
        .then((x) => x.accounts[0]);

      this.setAsyncState({ loading: false });
      this.props.onSubmit(updatedAccount);
    } catch (e) {
      console.error(e);
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  onNewCustomer(res) {
    try {
      this.setAsyncState({
        customer: res.customer,
        visibleModal: null,
        modalData: null,
        customers: [],
        customerQuery: "",
      });
    } catch (e) {
      this.setAsyncState({ error: e.message });
    }
  }

  retriveCustomerId = 0;
  async retriveCustomers(q) {
    try {
      let retriveCustomerId = Date.now();
      this.retriveCustomerId = retriveCustomerId;

      let where = {};
      if (!q) {
        this.setAsyncState({ loadingCustomers: false, customers: [] });
        return;
      } else {
        where = {
          $or: [
            {
              fullName: { $regex: q, $options: "i" },
            },
          ],
        };
      }

      this.setAsyncState({ loadingCustomers: true });

      const { customers } = await api.get("v1/customer", {
        queryStr: JSON.stringify({
          where,
          limit: 10,
        }),
      });

      if (this.retriveCustomerId === retriveCustomerId) {
        this.setAsyncState({ customers, loadingCustomers: false });
      }
      return customers.map((x) => ({ ...x, value: x._id, label: x.fullName }));
    } catch (e) {
      console.error(e.message);
      this.setAsyncState({ loadingCustomers: false });
    }
  }

  searchCustomerTimer = null;
  async searchCustomer(q) {
    this.setAsyncState({ customerQuery: q });
    clearTimeout(this.searchCustomerTimer);

    setTimeout(() => {
      this.retriveCustomers(q);
    }, 200);
  }

  calcDate({ month, day, date }) {
    let monthUpdated = new Date(
      new Date(new Date(date).setHours(0, 0, 0, 0)).setMonth(
        new Date(date).getMonth() + parseInt(month || 0)
      )
    );

    let dayUpdated = new Date(
      new Date(monthUpdated).getTime() + 1000 * 60 * 60 * 24 * (day || 0)
    );

    return dayUpdated;
  }

  renderForm() {
    const {
      props: { renderModal = false },
      state: {
        error,
        interestRate,
        collector,
        interestPeriod,
        customer,
        customerQuery,
        visibleModal,
        modalData,
        customers,
        loadingCustomers,
        note,
        avgYearlyInterestRate,
        accountType,
        depositInterval,
        openingDate,
        endingDate,
        returningDate,
        recurringPeriod,
        recurringAmount,
        collectorCommission,
        extra,
      },
    } = this;

    const isEditing = !!this.props.account?._id;

    return (
      <>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
          ref={this.formRef}
        >
          <ButtonGroup className="mb-3">
            {[{ value: "loan" }, { value: "deposit" }].map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`customer-reciept-range-radio-${idx}`}
                type="radio"
                variant={"outline-success"}
                name="radio"
                value={radio.value}
                checked={accountType === radio.value}
                onChange={({ target: { value } }) =>
                  this.setAsyncState({
                    accountType: value,
                    collectorCommission: value === "deposit" ? 1 : 3,
                  })
                }
                disabled={isEditing}
              >
                {radio.name || _.startCase(radio.value)}
              </ToggleButton>
            ))}
          </ButtonGroup>

          <Form.Group className="mb-3 select-customer-from-group">
            {customer?._id ? (
              <div>
                <Form.Label>Selected Customer</Form.Label>
                <Table striped bordered hover size="sm">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{getFullName(customer)}</td>
                    </tr>
                    <tr>
                      <th>Phone</th>
                      <td>{getPhoneNumber(customer).formated}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{customer.email}</td>
                    </tr>
                    <tr>
                      <th>Address</th>
                      <td className="multiline">{customer.address}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : (
              <Form.Label>Select Customer</Form.Label>
            )}

            {!isEditing ? (
              <>
                <InputGroup>
                  <FormControl
                    placeholder="Search Existing Customer"
                    value={customerQuery}
                    onChange={(e) => this.searchCustomer(e.target.value)}
                    name="customerQuery"
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() =>
                      this.setAsyncState({
                        visibleModal: "editCustomer",
                        modalData: null,
                      })
                    }
                  >
                    Create New Customer
                  </Button>
                </InputGroup>
                {loadingCustomers ? (
                  <Form.Text className="text-muted">Loading...</Form.Text>
                ) : (
                  <Form.Text className="text-muted">
                    Select customer from search result or create new
                  </Form.Text>
                )}
                <ListGroup>
                  {customers?.map((item) => {
                    return (
                      <ListGroup.Item
                        key={item._id}
                        action
                        onClick={() =>
                          this.setAsyncState({
                            customer: item,
                            customers: [],
                            customerQuery: "",
                          })
                        }
                      >
                        {`${getFullName(item)} (${
                          getPhoneNumber(item).formated
                        }, ${item.email})`}
                      </ListGroup.Item>
                    );
                  })}
                </ListGroup>
              </>
            ) : null}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Interest Rate</Form.Label>
            <Form.Control
              type="number"
              min={0}
              step={0.0000000001}
              placeholder="Interest Rate"
              value={interestRate}
              onChange={({ target: { value } }) =>
                this.setAsyncState({
                  interestRate: value,
                  avgYearlyInterestRate:
                    interestModule.calculateAvgYearlyInterest({
                      interestRate: value,
                      interestPeriod,
                      accountType,
                      openingDate,
                      endingDate,
                    }),
                })
              }
              required
              name="interestRate"
              disabled={isEditing && ["loan"].includes(accountType)}
            />
            {accountType === "loan" ? (
              <Form.Text className="text-muted">
                {interestPeriod} interest rate
              </Form.Text>
            ) : null}
          </Form.Group>

          {accountType === "loan" ? (
            <Form.Group className="mb-3">
              <Form.Label>Interest Period</Form.Label>
              <Form.Control
                as="select"
                value={interestPeriod || ""}
                onChange={({ target: { value } }) =>
                  this.setAsyncState({
                    interestPeriod: value,
                    avgYearlyInterestRate:
                      interestModule.calculateAvgYearlyInterest({
                        interestRate,
                        interestPeriod: value,
                      }),
                  })
                }
                required
                name="interestPeriod"
                disabled={isEditing}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="daily">Daily</option>
                <option value="monthly">Monthly</option>
              </Form.Control>
            </Form.Group>
          ) : null}

          {accountType === "loan" ? (
            <Form.Group className="mb-3">
              <Form.Label>Yearly Interest Rate</Form.Label>
              <Form.Control
                type="number"
                name="yearlyInterestRate"
                placeholder="Yearly Interest Rate"
                value={avgYearlyInterestRate}
                onChange={({ target: { value } }) =>
                  this.setAsyncState({
                    avgYearlyInterestRate: value,
                    interestRate: parseFloat(
                      interestModule
                        .getInterestRateFromYearly({
                          interestRate: value,
                          interestPeriod,
                        })
                        ?.toFixed?.(5)
                    ),
                  })
                }
                required
                disabled={isEditing}
              />
              <Form.Text className="text-muted">
                Total interest in one year, from {interestPeriod}{" "}
                {interestRate ? `${interestRate}%` : "Interest Rate"}
              </Form.Text>
            </Form.Group>
          ) : accountType === "deposit" ? (
            <Form.Group className="mb-3">
              <Form.Label>Avg Yearly Interest</Form.Label>
              <Form.Control
                type="number"
                name="avgYearlyInterest"
                placeholder="Avg Yearly Interest"
                value={extra?.avgYearlyInterestRate || ""}
                onChange={({ target: { value } }) =>
                  this.setAsyncState({
                    extra: { ...(extra || {}), avgYearlyInterestRate: value },
                  })
                }
                required
              />
              <Form.Text className="text-muted">
                This is not being considered on interest calculations
              </Form.Text>
            </Form.Group>
          ) : null}

          {accountType === "deposit" ? (
            <Form.Group className="mb-3">
              <Form.Label>Deposit Interval</Form.Label>
              <Form.Control
                name="depositInterval"
                as="select"
                value={depositInterval || ""}
                onChange={({ target: { value } }) =>
                  this.setAsyncState({
                    depositInterval: value,
                  })
                }
                required
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="daily">Daily</option>
                <option value="monthly">Monthly</option>
                <option value="fixed">Fixed</option>
              </Form.Control>
            </Form.Group>
          ) : null}

          {accountType === "deposit" ? (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Recurring Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="recurringAmount"
                  placeholder="Estimate Recurring Amount"
                  value={recurringAmount}
                  onChange={({ target: { value } }) =>
                    this.setAsyncState({
                      recurringAmount: value,
                    })
                  }
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Opening Date</Form.Label>
                <Form.Control
                  type="date"
                  value={moment(new Date(openingDate).getTime()).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={({ target: { value } }) => {
                    const openingDate = new Date(
                      new Date(value).setHours(0, 0, 0, 0)
                    );
                    const endingDate = this.calcDate({
                      month: recurringPeriod,
                      day: -1,
                      date: value,
                    });
                    const returningDate = this.calcDate({
                      month: recurringPeriod,
                      day: 4,
                      date: value,
                    });
                    this.setAsyncState({
                      openingDate,
                      endingDate,
                      returningDate,
                      avgYearlyInterestRate:
                        interestModule.calculateAvgYearlyInterest({
                          interestRate,
                          interestPeriod,
                          accountType,
                          openingDate,
                          endingDate,
                        }),
                    });
                  }}
                  required
                  name="openingDate"
                />
              </Form.Group>
              {isEditing ? null : (
                <Form.Group className="mb-3">
                  <Form.Label>Period</Form.Label>
                  <InputGroup className="mb-3">
                    <FormControl
                      type={"number"}
                      placeholder="no of months"
                      value={recurringPeriod}
                      onChange={({ target: { value } }) => {
                        const endingDate = this.calcDate({
                          month: value,
                          day: -1,
                          date: openingDate,
                        });
                        const returningDate = this.calcDate({
                          month: value,
                          day: 4,
                          date: openingDate,
                        });
                        this.setAsyncState({
                          recurringPeriod: value,
                          endingDate,
                          returningDate,
                          avgYearlyInterestRate:
                            interestModule.calculateAvgYearlyInterest({
                              interestRate,
                              interestPeriod,
                              accountType,
                              openingDate,
                              endingDate,
                            }),
                        });
                      }}
                      required
                      name="period"
                      disabled={!openingDate}
                    />
                    <InputGroup.Text id="basic-addon1">Months</InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              )}
              <Form.Group className="mb-3">
                <Form.Label>Ending Date</Form.Label>
                <Form.Control
                  type="date"
                  value={moment(new Date(endingDate).getTime()).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={(e) => {
                    const endingDate = new Date(
                      new Date(e.target.value).setHours(0, 0, 0, 0)
                    );

                    this.setAsyncState({
                      endingDate,
                      avgYearlyInterestRate:
                        interestModule.calculateAvgYearlyInterest({
                          interestRate,
                          interestPeriod,
                          accountType,
                          openingDate,
                          endingDate,
                        }),
                    });
                  }}
                  required
                  name="endingDate"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Returning Date</Form.Label>
                <Form.Control
                  type="date"
                  value={
                    returningDate
                      ? moment(new Date(returningDate).getTime()).format(
                          "YYYY-MM-DD"
                        )
                      : ""
                  }
                  onChange={(e) => {
                    const returningDate = new Date(
                      new Date(e.target.value).setHours(0, 0, 0, 0)
                    );

                    this.setAsyncState({
                      returningDate,
                    });
                  }}
                  name="returningDate"
                  required
                />
              </Form.Group>
            </>
          ) : null}

          <Form.Group className="mb-3">
            <Form.Label>Collector</Form.Label>
            <Form.Control
              as="select"
              value={collector?._id || collector || ""}
              onChange={(e) =>
                this.setAsyncState({ collector: e.target.value })
              }
              required
              name="collector"
            >
              <option value="" disabled>
                Select Collector
              </option>
              {this.props.agents?.map((x) => (
                <option key={x._id} value={x._id}>
                  {getFullName(x)}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Collector's Commission (%)</Form.Label>
            <Form.Control
              type="number"
              placeholder="Collector's Commission"
              value={collectorCommission}
              onChange={(e) =>
                this.setAsyncState({ collectorCommission: e.target.value })
              }
              name="ccomission"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Note</Form.Label>
            <Form.Control
              as={"textarea"}
              placeholder="Note"
              value={note}
              onChange={(e) => this.setAsyncState({ note: e.target.value })}
              rows={3}
              name="note"
            />
          </Form.Group>

          <div className="errormsg">{error}</div>

          {renderModal ? null : (
            <Button variant="primary" type="submit">
              Submit
            </Button>
          )}
        </Form>
        <EditCustomer
          {...{
            key: `editCustomer-${
              visibleModal === "editCustomer"
                ? modalData?.customer?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editCustomer",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewCustomer(item),
            ...(modalData || {}),
          }}
        />
      </>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: this.props.account?._id ? "Edit Account" : "Add New Account",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({
  agents: state.vState.AGENTS_SCREEN?.agents,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const EditAccount = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAccountInner);

export default EditAccount;
